// react
import * as React from "react";
// material
import MuiThemeProvider from "material-ui/styles/MuiThemeProvider";
import diyLightTheme = require("diy/material-ui/diyLightTheme");
// global
import l10n = require("diy/util/l10n");
// local
import {StepData} from "../StepData";
import {Header} from "./Header";
import {Sidebar} from "./Sidebar";
import {Content} from "./Content";
import {Errors, Mode as ErrorsMode} from "./Errors";
import {Observable} from "diy/util/Observable";

interface GuideProps {
    steps: StepData[];
    observable?: Observable;
    initialStep: StepData;
    showSidebar: boolean;
    tabletView: boolean;
    onClose(step: StepData): void;
}

interface GuideState {
    selectedStep: StepData;
}

export class Guide extends React.Component<GuideProps, GuideState> {
    private contentWrapper: HTMLElement;

    constructor(props: GuideProps, context: any) {
        super(props, context);

        this.state = {
            selectedStep: props.initialStep,
        };
    };

    render() {
        return (
            <MuiThemeProvider muiTheme={diyLightTheme}>
                <div className="onboarding container">
                    <div className="content-wrapper" ref={ref => this.contentWrapper = ref}>
                        <Header
                            titleText={l10n.getString('onboardingGuide.title') }
                            onCloseClick={() => {
                                this.props.onClose(this.state.selectedStep);
                            }}
                        />
                        {this.props.steps.length === 0 ?
                            <Errors mode={ErrorsMode.Critical} text={l10n.getString('onboardingGuide.errors.all') } /> :
                            <div style={{ display: "flex" }}>
                                {this.props.showSidebar ?
                                    <Sidebar
                                        steps={this.props.steps}
                                        liteVersion={this.props.tabletView}
                                        activeStep={this.state.selectedStep}
                                        onStepSelect={this.onStepChange}
                                    />
                                : null }
                                <Content
                                    stepData={this.state.selectedStep}
                                    liteVersion={this.props.tabletView}
                                    observable={this.props.observable}
                                    onBeforeHelp={() => {
                                        this.props.onClose(this.state.selectedStep);
                                    }}
                                />
                            </div>
                        }
                    </div>
                </div>
            </MuiThemeProvider>
        );
    };

    private onStepChange = (step: StepData) => {
        if (this.state.selectedStep !== step) {
            this.props.observable.notify({
                eventName: 'diy-editor-onboardingGuide-stepChange',
                step: step
            });
        }
        this.setState({
            selectedStep: step,
        } as GuideState);
    };
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/site-admin/onboarding-guide/components/Guide.tsx
 **/